import merge from 'lodash/merge'
import produce from 'immer'

export const actions = {
  LOAD_STATE: 'LOAD_STATE',
  LOAD_CONFIG: 'LOAD_CONFIG',
  SET_COMMUNITY: 'SET_COMMUNITY',
  UPDATE_DESIGN: 'UPDATE_DESIGN',
  UPDATE_LOT: 'UPDATE_LOT',
  UPDATE_LABEL: 'UPDATE_LABEL',
  UPDATE_BOARD: 'UPDATE_BOARD',
  CHANGE_BOARD: 'CHANGE_BOARD',
  ADD_ITEM: 'ADD_ITEM',
  ADD_ITEMS: 'ADD_ITEMS',
  UPDATE_ITEM: 'UPDATE_ITEM',
  REORDER_ITEM: 'REORDER_ITEM',
  UPDATE_ITEM_ATTR: 'UPDATE_ITEM_ATTR',
  REMOVE_ITEM: 'REMOVE_ITEM',
  RESET_BOARD: 'RESET_BOARD',
  CLONE_BOARD: 'CLONE_BOARD',
  CLEAR_SLOT: 'CLEAR_SLOT',
}

const immutableDesignReducer = (draftState = {}, action) => {
  // console.log('reducing', action, draftState)

  switch (action.type) {
    case actions.LOAD_STATE:
      if (action.currentBoard) {
        return merge(draftState, action.currentBoard, action.state)
      }
      return merge(draftState, action.state)

    case actions.LOAD_CONFIG:
      draftState.config = action.config
      break
    case actions.SET_COMMUNITY:
      draftState.community = action.community
      break
    case actions.UPDATE_LABEL:
      draftState.externalLabel = action.externalLabel
      break
    case actions.UPDATE_DESIGN:
      draftState[ action.key ] = action.value
      break
    case actions.UPDATE_LOT:
      const newState = {
        ...draftState,
        lot: { ...draftState.lot, ...action.lot }
      }
      // console.log('lot equal?', JSON.stringify(state) == JSON.stringify(newState), JSON.stringify(state, null, 2), JSON.stringify(newState, null, 2))
      return newState

    case actions.CHANGE_BOARD:
      draftState.currentBoardIndex = parseInt(action.index)
      break

    case actions.UPDATE_BOARD: {
      if (action.board.label2) {
        action.board.divider = {
          x: 585,
          y: 0,
          points: [ 0, 20, 0, 830 ],
        }
      } else if (!action.board.divider) {
        action.board.divider = null
      }
      draftState.boards[ draftState.currentBoardIndex ] = {
        ...draftState.boards[ draftState.currentBoardIndex ],
        ...action.board
      }
      break
    }
    case actions.RESET_BOARD:
      draftState.boards[ draftState.currentBoardIndex ].items = []
      break
    case actions.CLONE_BOARD:
      draftState.id = 'NEW'
      break
    case actions.ADD_ITEM:
      draftState.boards[ draftState.currentBoardIndex ].items.push(action.item)
      break
    case actions.ADD_ITEMS: {
      action.items.forEach(item => { draftState.boards[ draftState.currentBoardIndex ].items.push(item)})
      break
    }
    case actions.UPDATE_ITEM: {
      // console.log('UPDATE_ITEM', action, state)
      const item = action.item
      if (action.item) {
        const items = draftState.boards[ draftState.currentBoardIndex ].items
        let itemIndexToUpdate = items.findIndex((it => it.id === item.id))
        let itemToUpdate = items[ itemIndexToUpdate ]
        // console.log('updating item', itemToUpdate)
        items[ itemIndexToUpdate ] = { ...itemToUpdate, ...item }

        draftState.boards[ draftState.currentBoardIndex ].items = items
      }
      break
    }
    case actions.UPDATE_ITEM_ATTR: {
      if (action.item && action.key && action.value) {
        const item = action.item
        const items = draftState.boards[ draftState.currentBoardIndex ].items
        let itemIndexToUpdate = items.findIndex((it => it.id === item.id))
        let itemToUpdate = items[ itemIndexToUpdate ]
        items[ itemIndexToUpdate ].attributes = { ...itemToUpdate.attributes, [ action.key ]: action.value }
        // console.log('updated attrs', itemToUpdate)

        draftState.boards[ draftState.currentBoardIndex ].items = items
      }

      break
    }

    case actions.REORDER_ITEM: {
      const item = action.item
      const items = draftState.boards[ draftState.currentBoardIndex ].items
      let itemIndexToUpdate = items.findIndex((it => it.id === item.id))
      // z-index order, so front=end of array and back=0
      const newIndex = action.place === 'back' ? 0 : action.place === 'front' ? (items.length-1) : itemIndexToUpdate
      items.splice(itemIndexToUpdate, 1)
      items.splice(newIndex, 0, item)
      draftState.boards[ draftState.currentBoardIndex ].items = items
      break
    }
    case actions.REMOVE_ITEM: {
      if (action.item) {
        let items = draftState.boards[ draftState.currentBoardIndex ].items
        items = items.filter(it => it.id !== action.item.id)
        draftState.boards[ draftState.currentBoardIndex ].items = items
      }
      break
    }
    case actions.CLEAR_SLOT: {
      let items = draftState.boards[ draftState.currentBoardIndex ].items
      items = items.filter(it => it.slotId !== action.slot.id)
      draftState.boards[ draftState.currentBoardIndex ].items = items
      break
    }
    default:
      console.log('unknown action?!', action)
      break
  }
}

export const designReducer = produce(immutableDesignReducer)

export default designReducer